import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const AllInsightsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px 12px 16px;
  border-bottom: 1px solid var(--border-soft);
  min-width: 350px;
`;

export const AllInsightsLabel = styled.span`
  ${typographyV2.bodySm};
`;

export const AssetList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 280px;
  overflow-y: auto;
`;

export const AssetRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  gap: 12px;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  > div {
    flex-direction: row;
    align-items: center;
  }

  label {
    align-items: center;
  }

  label > div:first-of-type {
    margin-top: 0;
  }
`;

export const EntityName = styled.span`
  ${typographyV2.bodySm};
  color: var(--text-soft);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: right;
  min-width: 0;
  flex: 1;
`;
